module.exports = __webpack_public_path__ + "media/images/icons/car-with-key-1faaee3b745fd9d0dddecdd7fbe2fe7a.svg";